import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Cookies from 'js-cookie';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { logout } from '../store/auth.js';

export default function ButtonAppBar() {
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const dispatch = useDispatch();

  function _logout() {
    Cookies.remove('token');
    dispatch(logout());
    navigate('/login');
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position='static'>
        <Toolbar>
          <Typography variant='h6' component='div' sx={{ flexGrow: 1 }}>
            <Link className='text-white' to='/'>
              Expensor
            </Link>
          </Typography>

          <Link to='/bills' className='text-white'>
            <Button color='inherit'>Split Bills</Button>
          </Link>

          <Link to='/filter' className='text-white'>
            <Button color='inherit'>Filter</Button>
          </Link>

          {isAuthenticated && (
            <Button color='inherit' onClick={_logout}>
              Logout
            </Button>
          )}

          {!isAuthenticated && (
            <>
              <Link to='/login' className='text-white'>
                <Button color='inherit'>Login</Button>
              </Link>
              <Link to='/register' className='text-white'>
                <Button color='inherit'>Register</Button>
              </Link>
            </>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}
